import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@angular/cdk/layout';
import { ConfirmDialogService } from './@shared/components/confirm-dialog/confirm-dialog.service';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { StoreModule, Store, combineReducers } from '@ngrx/store';
import { CoreModule } from './@core';
import { SharedModule } from './@shared';
import { ToastrModule } from 'ngx-toastr';
import { CustomToastrComponent } from './@core/toastr/app-toastr/custom-toastr/custom-toastr.component';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { appBarrelReducer } from './@core/store/reducer';
import { appBarrelEffect } from './@core/store/effect';
import { MaterialDesignFrameworkModule } from 'angular6-json-schema-form';
import { FeedbackReasonDialogComponent } from './knowledge-center/feedback-reason-dialog/feedback-reason-dialog.component';
import { ChartsModule } from 'ng2-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ProfileComponent } from './profile/profile.component';
import { EinoiveFileTypeComponent } from './reports/einoive-file-type/einoive-file-type.component';
import { FileDragNDropDirective } from './sets/directives/file-drag-n-drop.directive';
import { DropzoneDirective } from './sets/directives/dropzone.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { HttpClientModule } from '@angular/common/http';
import { DeleteSetVariantNewDialogComponent } from './sets/delete-set-variants/delete-set-variant-new-dialog/delete-set-variant-new-dialog.component';




@NgModule({
    declarations: [
        AppComponent,
        FeedbackReasonDialogComponent,
        ProfileComponent,
        EinoiveFileTypeComponent,
        FileDragNDropDirective,
        DropzoneDirective,
        TermsConditionComponent,
        DeleteSetVariantNewDialogComponent

    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule,
        LayoutModule,
        NgxScrollTopModule,
        StoreModule.forRoot(appBarrelReducer),
        EffectsModule.forRoot(appBarrelEffect),
        CoreModule,
        SharedModule,
        ChartsModule,
        ToastrModule.forRoot({
            toastComponent: CustomToastrComponent,
            preventDuplicates: true,
            newestOnTop: true,
            resetTimeoutOnDuplicate: true,
            closeButton: true,
            positionClass: 'toast-top-center',
            timeOut: 3000,
            tapToDismiss: false,
            toastClass: 'toast toast-bootstrap-compatibility-fix',
        }),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
        }),
        MaterialDesignFrameworkModule,
        NgxSkeletonLoaderModule,
        MatDialogModule,
        FormsModule,
        MatSnackBarModule,
        HttpClientModule
    ],
    providers: [ConfirmDialogService],
    bootstrap: [AppComponent],
})
export class AppModule {}
